import OrderByV2Provider from './hooks/useOrderByV2';

import { OrderByV2Props } from './@types/OrderByV2Props';

import Content from './handles/Content';
import { useState } from 'react';

const OrderByV2 = (props: OrderByV2Props) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<OrderByV2Provider {...props}>
			<Content isOpen={isOpen} setIsOpen={setIsOpen} />
		</OrderByV2Provider>
	);
};

export default OrderByV2;
